import mapboxgl from '!mapbox-gl';
import $ from 'jquery';

import { $Elements, Classes, Durations } from '../global/constants';

export let mapInitialized = false;
export let mapMarkers = [];

mapboxgl.accessToken = 'pk.eyJ1IjoiY2FzdGlsbG9uY2FyYWN0ZXJlcyIsImEiOiJjbDV3aHIyNnUwanBrM2NsdHg3ZDFydDVxIn0.pRjwMwZj3XD6eZrb4XT7jw';

export const propertiesColors = {
	accent: '#3b4859',
	fill: '#9F9275',
	outline: '#f8f6f2'
};

export const map = (document.getElementById('main-map')) ? new mapboxgl.Map({
	container: 'main-map',
	zoom: 10,
	center: [-0.045, 44.925],
	pitch: 0,
	bearing: 0,
	antialias: true,
	interactive: true,
	style: 'mapbox://styles/castilloncaracteres/cl60xflaf000v15pka2zrfwue',
	attributionControl: false
}) : null;

if(map) {

	map.on('load', () => {

		map.addSource('terrain-dem', {
			'type': 'raster-dem',
			'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
			'tileSize': 512,
			'maxzoom': 14
		});

		map.addLayer({
			'id': 'hillshades',
			'source': 'terrain-dem',
			'type': 'hillshade',
			'paint': {
				'hillshade-accent-color': propertiesColors.accent,
				'hillshade-shadow-color': propertiesColors.accent,
				'hillshade-exaggeration': 0.9
			},
		});

		map.setStyle({ ...map.getStyle(), 'transition': { duration: Durations.animations, delay: 0 } });

		map.setPaintProperty('proprietes', 'fill-color', propertiesColors.fill);
		map.setPaintProperty('proprietes', 'fill-outline-color', propertiesColors.outline);

		map.setPaintProperty('appellation', 'fill-color', propertiesColors.fill);
		map.setPaintProperty('appellation', 'fill-outline-color', propertiesColors.outline);

		mapInitialized = true;
		$Elements.document.trigger('map.initialized');
	});
}

export function hideAppellation() {
	map.setPaintProperty('appellation', 'fill-opacity', 0);
	$('.property-marker, .property-infowindow').removeClass(Classes.active);
}

export function showAppellation() {
	map.setPaintProperty('appellation', 'fill-opacity', 0.8);
	$('.property-marker').addClass(Classes.active);
}

export function hideProperties() {
	map.setPaintProperty('proprietes', 'fill-opacity', 0);
}

export function showProperty(name) {
	map.setPaintProperty('proprietes', 'fill-opacity', ['match', ['get', 'name'], name, 1, 0]);
}

export function getPropertyFeatures(name) {
	return map.queryRenderedFeatures({ layers: ['proprietes'], filter: ['==', ['get', 'name'], name] })
}

export function easeTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = Durations.animations * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.easeTo({ ...location, essential: true });
	});
}

export function flyTo(location) {

	if(typeof location.duration === 'undefined') {
		location.duration = Durations.animations * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.flyTo({ ...location, essential: true });
	});
}

export function fitBounds(bounds, options = {}) {

	if(typeof options.duration === 'undefined') {
		options.duration = Durations.animations * 2;
	}

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.fitBounds(bounds, { ...options, essential: true });
	});
}
